import React, {Component} from 'react';

class NameComponent extends Component {
    constructor(props){
        super(props)

    }

    render(){
        return(
            <div style = {{ flexDirection:'row',display:'flex', alignItems:'center', alignContent:'center', width:this.props.width || '100%'}}>
                <h4 style = {{color: this.props.textColor || 'black', textAlign:'center', alignSelf:'center',  width:'100%', backgroundColor:this.props.backgroundColor, borderRadius:20}}>{this.props.text}</h4>
            </div>
        )
    }
}

export default NameComponent